// output: [ { id: '333282', name: 'My first experiment', activeVariantId: '29997' }, ... ]
// or [] if no active experiments

const getActiveVariantForXP = (experimentId, activeVariants) => {
  const activeVariant = activeVariants[experimentId];

  if (activeVariant) {
    return activeVariant;
  }

  return 'VARIANT_NOT_FOUND';
};

export function getActiveExperimentsData() {
  const experiments = [];

  if (typeof window !== 'undefined' && typeof window?.FIGPII?.experimentManager !== 'undefined') {
    const activeExperimentsForUser = window.FIGPII.experimentManager.getActiveInstances();
    const activeVariantsForUser = window.FIGPII.experimentManager.getActiveVariations();

    if (!activeExperimentsForUser
        || !activeVariantsForUser
        || activeExperimentsForUser.length === 0
        || Object.keys(activeVariantsForUser).length === 0) {
      return experiments;
    }

    activeExperimentsForUser.forEach(experiment => {
      experiments.push({
        id: experiment.id,
        name: experiment.name,
        activeVariantId: getActiveVariantForXP(experiment.id, activeVariantsForUser),
      });
    });
  }

  return experiments;
}
